import { Assert } from '@team/assert';
import { NOT_FOUND_ELEMENT_INDEX } from './const.js';

export function isNotFoundElement(index: number) {
  return Assert.isEquals(NOT_FOUND_ELEMENT_INDEX, index);
}
